module.exports = __webpack_public_path__ + "static/assets/3864ca20f8165ca4050a42abd2ea1282.png";